// @flow

import { createSelector } from 'reselect'
import arraySort from 'array-sort'

const _getAssessmentSkills = (state: Object) =>
  state.manifest.data.assessment_skills
const _getAbsenceReasons = (state: Object) =>
  state.manifest.data.absence_reasons
const _getGradeLevels = (state: Object) => state.manifest.data.grade_levels

export const getAssessmentSkills = createSelector(
  [_getAssessmentSkills],
  (as): Array<Object> => {
    const assessmentSkills = []

    Object.keys(as).forEach((key, index) => {
      assessmentSkills.push({
        id: parseInt(key),
        name: Object.values(as)[index].name,
        sort: Object.values(as)[index].sort_order
      })
    })

    return arraySort(assessmentSkills, ['sort'])
  }
)

export const getAbsenceReasons = createSelector(
  [_getAbsenceReasons],
  (as): Array<Object> => {
    const absenceReasons = []

    Object.keys(as).forEach((key, index) => {
      absenceReasons.push({
        id: parseInt(key),
        name: Object.values(as)[index].name,
        sort: Object.values(as)[index].sort_order
      })
    })

    return arraySort(absenceReasons, ['sort'])
  }
)

export const getGradeLevels = createSelector(
  [_getGradeLevels],
  (gl): Array<Object> => {
    const gradeLevels = []

    Object.keys(gl).forEach((key, index) => {
      gradeLevels.push({
        id: parseInt(key),
        abbreviation: Object.values(gl)[index].abbreviation,
        name: Object.values(gl)[index].name,
        sort: Object.values(gl)[index].sort_order
      })
    })

    return gradeLevels
  }
)
